import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  title: {
    marginTop: 40,
    marginBottom: 8,
  },
  description: {
    marginBottom: 24,
  },
  submitButton: {
    marginTop: 40,
    width: '100%',
    margin: '16px 0 56px',
  },
  lockImage: {
    transform: 'translateY(calc(-50% + 60px))',
  },
}));

export default useStyles;
